import { Drawer, Form } from 'antd';
import { first } from 'lodash';
import { forwardRef, useImperativeHandle, useMemo, useRef, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { ICategoryItemData } from 'services/shop/types/categories';
import styled from 'styled-components';
import ActionsStep from './ActionsStep';
import { CategoriesUI, ServicesUI } from './ServiceUI';
import { IFormValueServiceItem } from './types';
type ServiceBottomSheetProps = {};
export type ServiceBottomSheetRef = {
  open: (onChange: (services: IFormValueServiceItem[]) => void) => void;
};
export const useServiceBottomSheet = () => useRef<ServiceBottomSheetRef>(null);
const ServiceBottomSheet = forwardRef<ServiceBottomSheetRef, ServiceBottomSheetProps>((_, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const categories = shopSelectors.data.categories();
  const [_activeCategory, setActiveCategory] = useState<ICategoryItemData | null>(null);

  const activeCategory = useMemo(() => {
    if (!_activeCategory) return first(categories) || null;
    return _activeCategory;
  }, [_activeCategory, categories]);

  const callbackRef = useRef<(services: IFormValueServiceItem[]) => void>(() => undefined);

  const handleFinish = (values: any) => {
    const body = values as { services: IFormValueServiceItem[] };
    callbackRef.current(body.services);
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: async (_callbackRef) => {
      callbackRef.current = _callbackRef;
      form.resetFields();
      setOpen(true);
    },
  }));

  return (
    <>
      <Drawer contentWrapperStyle={{
        padding: 0, maxWidth: '476px',
        margin: '0 auto',
      }} bodyStyle={{ padding: 0 }} height={'80vh'} width={'476px'} placement="bottom" closable={false} onClose={() => setOpen(false)} open={open}>
        <Container form={form} onFinish={handleFinish}>
          <div className="title-select">Add Services</div>
          <Form.Item noStyle name={'services'} rules={[{ required: true, message: 'Please choose services' }]}>
            <CategoriesUI activeId={activeCategory?.id || ''} categories={categories} onChooseCate={setActiveCategory} />
          </Form.Item>
          <Form.Item noStyle name={'services'}>
            <ServicesUI services={activeCategory?.services || []} />
          </Form.Item>
        </Container>
        <ActionsStep onClose={() => setOpen(false)} onOk={() => form.submit()} />
      </Drawer>
    </>
  );
});
ServiceBottomSheet.displayName = 'ServiceBottomSheet';
export default ServiceBottomSheet;

const Container = styled(Form)`
min-height: 90vh;
padding: 16px;
.title-select {
  position: sticky;
  top: 0;
  background:#fff;
  padding: 8px 0;
  z-index: 22;
  color: #232F3E;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.48px;
}
`;
 